import { render } from "./DailyLimit.vue?vue&type=template&id=18ee1606"
import script from "./DailyLimit.vue?vue&type=script&lang=js"
export * from "./DailyLimit.vue?vue&type=script&lang=js"

import "./DailyLimit.vue?vue&type=style&index=0&id=18ee1606&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__